import { useRenderNotifier } from '@wui/common-library'
import { computed } from 'vue'

import { useCallSessionRoomStore } from '@/entities/call-session'
import { useWebRTC } from '@/entities/webrtc'

import { getDomExceptionErrorType, MediaDevicesErrorType } from '@/shared/composables/dom-exception-error-type'
import { useLocalization } from '@/shared/composables/localization'

import { switchScreenSharingInConferenceSession } from './conference-video-control'
import { switchScreenSharingInPrivateSession } from './private-video-control'

export const useToggleScreenSharing = () => {
  const { notifyError } = useRenderNotifier()
  const { t } = useLocalization()
  const { currentRTCSessionFacade } = useWebRTC()

  const isSharingScreen = computed(() => {
    return currentRTCSessionFacade.value?.isScreenSharing.value
  })
  const isGroup = computed(() => {
    if (!currentRTCSessionFacade.value) {
      return false
    }
    return !!useCallSessionRoomStore().getRoom(currentRTCSessionFacade.value.sessionId)?.isGroup
  })

  const toggle = async () => {
    try {
      if (isGroup.value) {
        await switchScreenSharingInConferenceSession()
      } else {
        await switchScreenSharingInPrivateSession()
      }
    } catch (error: unknown) {
      let key = 'errors.failedToShareScreen'
      if (error instanceof DOMException) {
        const errorType = getDomExceptionErrorType(error)
        if (errorType === MediaDevicesErrorType.UserPermissionDenied) {
          key = 'errors.rejectScreenSharing'
        }
      }
      notifyError(t(key))
    }
  }

  return {
    toggle,
    isSharingScreen,
  }
}
